(() => {
  const ROOT_SELECTOR = '[data-ng-pdp]';
  const INGREDIENTS_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/hf_20260905_143141_f7e6a46c-dd11-4526-8b4f-db84544cee54.png?v=1788622503';

  const MEDIA_BY_PLACEHOLDER = {
    'Healthy flow vs. sluggish flow diagram': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/hf_20260904_220229_623f00b3-f388-4c01-bb23-9dfbbfc8c94a.png?v=1788615180',
      alt: 'How healthy lymphatic drainage differs from sluggish flow'
    },
    'Benefit photo 1': {
      type: 'video',
      src: 'https://cdn.shopify.com/videos/c/o/v/eb89ad611ebb42e7a7ecb4ba309074b4.mp4',
      alt: 'The difference between fluid loss and deep drainage'
    },
    'Benefit photo 2': {
      type: 'video',
      src: 'https://cdn.shopify.com/videos/c/o/v/18b1004667d2493abe8d4a43b32da2d9.mp4',
      alt: 'Supporting healthier blood pressure, cholesterol and blood sugar'
    },
    'Benefit photo 3': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/hf_20260905_133736_664449b8-e571-4a44-9ec7-a98cc5c9c1c5.png?v=1788615524',
      alt: 'Wake up with a clearer mind'
    },
    'Benefit photo 4': {
      type: 'video',
      src: 'https://cdn.shopify.com/videos/c/o/v/3a07aec873224e8caa6b0384c35c1251.mp4',
      alt: 'Supporting the liver, kidneys and digestion'
    },
    'Bottle + four botanical images': {
      type: 'image',
      src: INGREDIENTS_IMAGE_URL,
      alt: 'Naturelle clinical-strength botanical formula'
    },
    'Doctor photo 1': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/michael-harris.png?v=1788615735',
      alt: 'Dr. Michael Harris'
    },
    'Doctor photo 2': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/Laura-Bennett.png?v=1788615734',
      alt: 'Dr. Laura Bennett'
    },
    'Doctor photo 3': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/Steven-Cole.png?v=1788615735',
      alt: 'Dr. Steven Cole'
    },
    'Night 1 photo': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/counter-feat.webp?v=1788617592',
      alt: 'Night 1 of the Naturelle clearing process'
    },
    'Week 1 photo': {
      type: 'video',
      src: 'https://cdn.shopify.com/videos/c/o/v/f13cb42e3b0246f1ae4759ed64718c7d.mp4',
      alt: 'Week 1 of the Naturelle clearing process'
    },
    'Month 1 photo': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/hf_20260905_141820_70d26ec6-85d0-4e0a-bb64-528991b4508f.png?v=1788617990',
      alt: 'Month 1 of the Naturelle clearing process'
    },
    'Ongoing use photo': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/timeline-4.webp?v=178861570',
      alt: 'Ongoing Naturelle use'
    },
    'Customer photo 1': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/01-linda-selfie-holding-naturelle.png?v=1788622212',
    },
    'Customer photo 2': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/03-two-bottles-counter.png?v=1788622211',
    },
    'Customer photo 3': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/02-outdoor-dog-holding-naturelle.png?v=1788622212',
    },
    'Customer photo 4': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/04-woman-bed-dog.png?v=1788622212',
    },
    'Customer photo 5': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/14-mirror-selfie.png?v=1788622211',
    },
    'Customer photo 6': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/15-ankle-comfort.png?v=1788622211',
    },
    'Customer photo 7': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/16-morning-face.png?v=1788622212',
    },
    'Final product photo': {
      type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/hf_20260905_134500_9e16547b-12d4-4ec0-b63a-b259b7fb745b.png?v=1788622991',
      alt: 'Woman stretching comfortably outdoors'
    }
  };

  const BENEFITS_LEAD_MEDIA = {
    type: 'image',
    src: 'https://cdn.shopify.com/s/files/1/0707/1861/9829/files/hf_20260904_221525_a4f78047-ed99-415e-93bc-6425bdd808f8.png?v=1788615172',
    alt: 'Why over 100,000 customers have switched to Naturelle'
  };

  const DOCTOR_NAMES = [
    'Dr. Michael Harris, MD',
    'Dr. Laura Bennett, MD',
    'Dr. Steven Cole, MD'
  ];

  const INGREDIENT_CROPS = [
    { alt: 'Horse chestnut seed extract', position: '11% 21%' },
    { alt: "Butcher's broom", position: '89% 21%' },
    { alt: 'Grape seed OPC', position: '11% 56%' },
    { alt: 'Dandelion leaf', position: '89% 56%' }
  ];

  function createMediaElement(media) {
    const element = document.createElement(media.type === 'video' ? 'video' : 'img');
    element.src = media.src;
    element.setAttribute('aria-label', media.alt);

    if (media.type === 'video') {
      element.autoplay = true;
      element.loop = true;
      element.muted = true;
      element.playsInline = true;
      element.preload = 'metadata';
      element.setAttribute('muted', '');
      element.setAttribute('playsinline', '');
      element.setAttribute('webkit-playsinline', '');
    } else {
      element.alt = media.alt;
      element.loading = 'lazy';
      element.decoding = 'async';
    }

    return element;
  }

  function initConfiguredMedia(root) {
    root.querySelectorAll('.ng-media-slot > span, .ng-review-card__media > span').forEach((placeholder) => {
      const media = MEDIA_BY_PLACEHOLDER[placeholder.textContent.trim()];
      if (!media) return;

      const slot = placeholder.parentElement;
      slot.style.padding = '0';
      placeholder.replaceWith(createMediaElement(media));

      if (/^Customer photo \d+$/.test(placeholder.textContent.trim())) {
        const photoDisclosure = slot.closest('.ng-review-card')?.querySelector('.ng-review-card__verified');
      }
    });

    root.querySelectorAll('.ng-review-card__media > span').forEach((placeholder) => {
      placeholder.parentElement.hidden = true;
    });

    root.querySelectorAll('.ng-benefit-stack').forEach((stack) => {
      if (stack.parentElement.querySelector(':scope > .ng-benefits-lead-media')) return;

      const mediaSlot = document.createElement('div');
      mediaSlot.className = 'ng-media-slot ng-benefits-lead-media';
      mediaSlot.style.cssText = 'aspect-ratio:16/9;margin:0 0 40px;padding:0;';
      mediaSlot.appendChild(createMediaElement(BENEFITS_LEAD_MEDIA));
      stack.before(mediaSlot);
    });

    root.querySelectorAll('.ng-ingredient-card__media').forEach((slot, index) => {
      const ingredient = INGREDIENT_CROPS[index];
      const placeholder = slot.querySelector(':scope > span');
      if (!ingredient || !placeholder || placeholder.classList.contains('ng-ingredient-crop')) return;

      const crop = document.createElement('span');
      crop.className = 'ng-ingredient-crop';
      crop.setAttribute('role', 'img');
      crop.setAttribute('aria-label', ingredient.alt);
      crop.style.backgroundImage = `url("${INGREDIENTS_IMAGE_URL}")`;
      crop.style.backgroundPosition = ingredient.position;
      placeholder.replaceWith(crop);
    });

    root.querySelectorAll('.ng-doctor-card').forEach((card, index) => {
      const name = card.querySelector('.ng-doctor-card__copy h3');
      if (name && DOCTOR_NAMES[index]) name.textContent = DOCTOR_NAMES[index];
    });
  }

  function findBuyBox() {
    return document.querySelector('.main-product-form')
      || document.querySelector('[id^="ProductInfo-"]')
      || document.querySelector('[id^="MainProduct-"]');
  }

  function initBuyButtons(root) {
    root.querySelectorAll('[data-ng-scroll-buy]').forEach((button) => {
      if (button.dataset.ngReady === 'true') return;
      button.dataset.ngReady = 'true';
      button.addEventListener('click', () => {
        const buyBox = findBuyBox();
        if (!buyBox) return;
        buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => {
          buyBox.querySelector('button, input, select')?.focus({ preventScroll: true });
        }, 550);
      });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-ng-carousel-wrap]').forEach((wrapper) => {
      if (wrapper.dataset.ngReady === 'true') return;
      wrapper.dataset.ngReady = 'true';

      const track = wrapper.querySelector('[data-ng-carousel]');
      const previous = wrapper.querySelector('[data-ng-carousel-prev]');
      const next = wrapper.querySelector('[data-ng-carousel-next]');
      if (!track) return;

      if (track.hasAttribute('data-ng-auto-carousel')) {
        initAutoCarousel(track);
      }

      if (!previous || !next) return;

      const step = () => Math.max(track.clientWidth * 0.92, 280);
      previous.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  function initAutoCarousel(track) {
    if (track.dataset.ngAutoReady === 'true') return;
    track.dataset.ngAutoReady = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const originals = Array.from(track.children);
    if (!originals.length) return;

    const clones = originals.map((card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      track.appendChild(clone);
      return clone;
    });

    let paused = false;
    let lastTime = performance.now();

    const setPaused = (value) => {
      paused = value;
      lastTime = performance.now();
    };

    const tick = (now) => {
      if (!paused && document.visibilityState === 'visible') {
        const firstCloneOffset = clones[0].offsetLeft;
        track.scrollLeft += Math.min(now - lastTime, 48) * 0.03;
        if (firstCloneOffset > 0 && track.scrollLeft >= firstCloneOffset) {
          track.scrollLeft -= firstCloneOffset;
        }
      }
      lastTime = now;
      window.requestAnimationFrame(tick);
    };

    track.addEventListener('pointerenter', () => setPaused(true));
    track.addEventListener('pointerleave', () => setPaused(false));
    track.addEventListener('pointerdown', () => setPaused(true));
    track.addEventListener('pointerup', () => setPaused(false));
    track.addEventListener('touchstart', () => setPaused(true), { passive: true });
    track.addEventListener('touchend', () => setPaused(false), { passive: true });
    track.addEventListener('focusin', () => setPaused(true));
    track.addEventListener('focusout', () => setPaused(false));
    window.requestAnimationFrame(tick);
  }

  function init(root = document) {
    root.querySelectorAll(ROOT_SELECTOR).forEach((pdp) => {
      initConfiguredMedia(pdp);
      initBuyButtons(pdp);
      initCarousels(pdp);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
